import React from 'react';
import { Modal, Box, Typography, Button, Grid, Paper } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const DownloadConfirmationModal = ({ open, onClose, onConfirm, reportName }) => {
    const userName = "Vaibhav Dhawan"; // Replace with dynamic user data if available
    const userEmail = "vaibhav.dhawan@prozo.com"; // Replace with dynamic user data if available
    const currentDateTime = new Date().toLocaleString();

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 700,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 2
            }}>
                <Typography variant="h6" component="h2" gutterBottom>
                    Report Download in Progress
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                        <Typography variant="body1">
                            <strong>User:</strong> {userName} ({userEmail})
                        </Typography>
                        <Typography variant="body1">
                            <strong>Login Date & Time:</strong> {currentDateTime}
                        </Typography>
                        <Typography variant="body1">
                            <strong>Report Being Downloaded:</strong> {reportName}
                        </Typography>
                    </Grid>
                </Grid>
                <Paper elevation={3} sx={{ p: 2, bgcolor: '#fff5f3', mb: 2 }}>
                    <Typography variant="body2" gutterBottom sx={{ color: 'red' }}>
                        <strong>Important Notice</strong>
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'rgb(102, 65, 56)' }} gutterBottom>
                        Please ensure that the user credentials used for this login belong to you. Unauthorized use of another person's credentials is a violation of Prozo's data security policies.
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'rgb(102, 65, 56)' }} gutterBottom>
                        By downloading this report, you confirm that:
                    </Typography>
                    <Box sx={{ pl: 2 }}>
                        <Typography variant="body2" sx={{ color: 'rgb(102, 65, 56)', mb: 0.5, lineHeight: 1.5 }}>
                            1. You have the necessary authorization to access and download this report.
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgb(102, 65, 56)', mb: 0.5, lineHeight: 1.5 }}>
                            2. You will not share this report with any third party, even within the Prozo ecosystem, unless they explicitly require access to this data.
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgb(102, 65, 56)', mb: 0.5, lineHeight: 1.5 }}>
                            3. Sharing any Prozo data with individuals or entities outside of Prozo is strictly prohibited and will result in disciplinary action.
                        </Typography>
                    </Box>
                    <Typography variant="body2" sx={{ color: 'rgb(102, 65, 56)' }} gutterBottom>
                        This activity is being logged and will be retained for the next 360 days.
                    </Typography>
                </Paper>
                <Button
                    variant="contained"
                    color="error"
                    onClick={onConfirm}
                    sx={{ mt: 2, borderRadius: 1 }}
                    startIcon={<DownloadIcon />}
                >
                    Acknowledge & Download
                </Button>
            </Box>
        </Modal>
    );
};

export default DownloadConfirmationModal; 